import React from "react";

import svg from "../../assets/images/icons/close_red.svg";

export const CloseRedIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Close"}
    />
);
